import Vue from 'vue'
import configs from '@/config'
import store from '@/vuex/store'

let resource = null
const actions = {
  getAllCategories: {
    method: 'GET',
    url: `${configs.api.getCategories}`,
  },
  getCategoryDetail: {
    method: 'GET',
    url: `${configs.api.getCategoryDetail}{id}`,
  },
  getCategoryTemplates: {
    method: 'GET',
    url: `${configs.api.getCategoryTemplates}`,
  },
  getAllCategoriesV2: {
    method: 'GET',
    url: `${configs.api.getCategories}`,
  },
  getFeaturedTemplates: {
    method: 'GET',
    url: `${configs.baseUrl}/api/templates/`,
  },
}
const initResource = () => {
  resource = Vue.resource('', {}, actions)
}
const getAllCategories = async () => {
  const res = await resource.getAllCategories()
  return res.body
}

const getAllCategoriesV2 = async (params) => {
  const res = await resource.getAllCategoriesV2(params)

  return res.body
}

const getFeaturedTemplates = async (params) => {
  const res = await resource.getFeaturedTemplates(params)

  return res.body
}

const getCategoryTemplates = async (params) => {
  const res = await resource.getCategoryTemplates(params)
  return res.body
}

const getCategoryDetail = async (id) => {
  if (store.getters['featureToggles/canUseNewComunityTemplate']) {
    const queryParams = {
      sortBy: 'isAdminPick,copyCount',
      id,
    }
    return getCategoryTemplates(queryParams)
  }
  const res = await resource.getCategoryDetail({ id })
  return res.body
}

export default {
  initResource,
  getAllCategories,
  getCategoryDetail,
  getAllCategoriesV2,
  getFeaturedTemplates,
  getCategoryTemplates,
}
